module.exports = __webpack_public_path__ + "img/arr-b.f11d3cf6.svg";